import api from "./http";

export const ApiSubsidi = {
    getAll:()=>{
        return api.get('/cakepin/subsidi')
    },
    getByLembagaNDonatur :(kode_lembaga,uuid_donatur,alumni)=>{
        return api.get(`/cakepin/subsidi/${kode_lembaga}/${uuid_donatur}/${alumni}`)
    }
}